import yup from 'src/libraries/validator.library';

const OperatorTailShape = {
  Operator: yup
    .object({
      operatorId: yup.number(),
      name: yup.string(),
      email: yup.string(),
      activeFlag: yup.boolean(),
      dispatchFlag: yup.boolean(),
    })
    .defined()
    .nullable(),
  TailNumber: yup
    .object({
      tailId: yup.number(),
      tailNumber: yup.string(),
    })
    .defined()
    .nullable(),
  otId: yup.number().required(),
};

export const OperatorTailSchema = yup
  .object()
  .shape({
    ...OperatorTailShape,
  })
  .defined();

export const OperatorTailListSchema = yup
  .object({
    count: yup.number(),
    rows: yup
      .array()
      .of(
        yup
          .object()
          .shape({
            ...OperatorTailShape,
          })
          .defined()
      )
      .defined(),
  })
  .defined();

export const OperatorTailFormSchema = yup
  .object()
  .shape({
    operatorId: yup.number().required(),
    tailId: yup.number().required(),
  })
  .defined();

export const OperatorTailNumberPayloadSchema = yup
  .object({
    operatorTail: yup
      .object({
        otId: yup.number(),
        operatorId: yup.number(),
        tailId: yup.number(),
      })
      .defined(),
  })
  .defined();

export type IOperatorTail = yup.InferType<typeof OperatorTailSchema>;
export type IOperatorTailList = yup.InferType<typeof OperatorTailListSchema>;
export type IOperatorTailForm = yup.InferType<typeof OperatorTailFormSchema>;
